import autosize from 'autosize'

(($) ->
  window.contently ||= {}
  window.contently.ui ||= {}

  UI = contently.ui
  default_selector = "body"

  # determine if true touch enabled device
  #  - hardware like surface should be desktop
  #  - ipads do not have pointer events
  #  - many browsers implement touch events to begin with
  #  - a touchpad may code as touch event
  # some older browsers will return neither so
  # currently what we code as a true touch device
  # has to return both touch events AND no pointer events
  # otherwise, view it as a desktop thing
  if typeof Modernizr != "undefined"
    UI.touch_device = !Modernizr.pointerevents && Modernizr.touchevents

  get_safe_context = (context) ->
    if typeof context == "undefined"
      context = default_selector
    $(context)

  filter_context = (context, search="") ->
    $context = get_safe_context(context)

    if $context.is(search)
      $selector = $context
    else
      $selector = $context.find(search)
    $selector

  UI.setup_validation = (context) ->
    $context = filter_context(context, "form")

    $context.each ->
      $(this).addClass("maskable").parsley()

      $(this).on "keydown", (e) ->
        if (e.metaKey || e.ctrlKey) && (e.which or e.keyCode) == 13
          $(e.currentTarget).closest("form").submit()

  UI.DATE_FORMATS =
    serverFormat: "YYYY-MM-DD HH:mm:ss"
    datepickerFormat: "M dd, yy"
    timepickerFormat: "h:i A"
    dateTimeLocal: "YYYY-MM-DDTHH:mm"
    userDisplayDate: "MMM DD, YYYY"
    userDisplayTime: "hh:mm A"
    userDisplayFull: "MMM D, YYYY hh:mma"

  UI.setup_date_inputs = (context) ->
    $context = filter_context(context, ".js-date-picker:not(.js-picker-loaded)")

    $context.each ->
      @type = "text"
      @placeholder = "Select a date"
      $(this)
        .addClass("js-date-picker js-picker-loaded")
        .wrap $("<div class='date-picker-container'>")
        .attr("autocomplete", "off")

      defaultOptions =
        dateFormat: UI.DATE_FORMATS.datepickerFormat
        dayNamesMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
        showOtherMonths: true
        selectOtherMonths: true

      dataOptions = $(this).data("datepickeroptions")
      $.extend(defaultOptions, dataOptions)
      $(this).datepicker defaultOptions

      dateValue = $(this).val()
      if dateValue != ""
        formattedDate = moment(dateValue).format(UI.DATE_FORMATS.userDisplayDate)
        $(this).val(formattedDate).trigger("change")

  UI.setup_time_inputs = (context) ->
    $context = filter_context(context, ".js-time-picker:not(.js-picker-loaded)")

    $context.each ->
      @type = "text"
      @placeholder = "Select a time"
      $(this)
        .addClass("js-time-picker js-picker-loaded")
        .wrap $("<div class='time-picker-container'>")
        .attr("autocomplete", "off")

      defaultOptions =
        timeFormat: UI.DATE_FORMATS.timepickerFormat
        autoclose: true

      dataOptions = $(this).data("timepickeroptions")
      $.extend(defaultOptions, dataOptions)
      $(this).timepicker defaultOptions

  UI.setup_datetime_inputs = (context) ->
    $context = filter_context(context, "input[type='datetime-local']:not(.hasDateTimePickers)")

    updateDatetimeLocal = ($input, typeToUpdate, value) ->
      dateTimePickers = $input.closest(".datetime-pickers-container")

      dateTimeArray = $input.val().split("T")

      currentDate = dateTimePickers.find(".js-date-picker")
      currentTime = dateTimePickers.find(".js-time-picker")

      formatDate = (date) ->
        moment(date, UI.DATE_FORMATS.userDisplayDate).format("YYYY-MM-DD")

      formatTime = (time) ->
        moment(time, UI.DATE_FORMATS.userDisplayTime).format("HH:mm")

      # if type to be updated is the date
      if typeToUpdate == "date"
        # set input value if not blank otherwise blank
        if value == ""
          dateTimeArray[0] = ""
        else
          dateTimeArray[0] = formatDate(value)

        # check if time in datetime exist
        unless dateTimeArray[1]
          if currentTime.val()
            # use current time if it is being passed
            dateTimeArray[1] = formatTime(currentTime.val())
          else
            # otherwise set and fill to 12
            dateTimeArray[1] = "12:00"
            currentTime.val(dateTimeArray[1])

      # if type to be updated is the time
      if typeToUpdate == "time"
        # set input value if not blank otherwise blank
        if value == ""
          dateTimeArray[1] = ""
        else
          dateTimeArray[1] = formatTime(value)

        # check if date in datetime exist
        unless dateTimeArray[0]
          if currentDate.val()
            # use current date if it is being passed
            dateTimeArray[0] = formatDate(currentDate.val())
          else
            # otherwise set and fill to today+5
            dateTimeArray[0] = moment().add(5, "days").format("YYYY-MM-DD")
            currentDate.val(dateTimeArray[0].format(UI.DATE_FORMATS.userDisplayDate))

      # format is DateTimeLocal
      newDateTime = dateTimeArray.join("T")
      $input.val(newDateTime).trigger("change")

    $context.each ->
      datetime_input = $(this).addClass("hasDateTimePickers hidden")
      datetime_input.wrap $("<div class='datetime-pickers-container'>")
      $datetimeContainer = $(this).closest(".datetime-pickers-container")

      # date input
      # exclude parsley because we want to validate the real
      # datetime-local and not this fake display input
      date_input = $("<input>").attr
        class: "js-date-picker"
        id: "#{datetime_input.attr('id')}_date"
        value: datetime_input.val().split("T")[0]
        "datetime-id": datetime_input.attr("id")
        "data-parsley-excluded": true
        autocomplete: off

      date_input.bind "change", (e) ->
        newDate = $(e.currentTarget).val()
        updateDatetimeLocal datetime_input, "date", newDate

      $datetimeContainer.append date_input
      contently.ui.setup_date_inputs date_input

      # time time
      # exclude parsley because we want to validate the real
      # datetime-local and not this fake display input
      time_input = $("<input>").attr
        class: "js-time-picker"
        id: "#{datetime_input.attr('id')}_time"
        value: datetime_input.val().split("T")[1]
        "datetime-id": datetime_input.attr("id")
        "data-parsley-excluded": true
        autocomplete: off

      time_input.bind "change", (e) ->
        newTime = $(e.currentTarget).val()
        updateDatetimeLocal datetime_input, "time", newTime

      $datetimeContainer.append time_input
      contently.ui.setup_time_inputs time_input

  UI.select2defaults =
    minimumResultsForSearch: 10
    dropdownParent: $("#page-container")

  UI.setup_select2 = (context) ->
    $context = get_safe_context(context)

    $context.find("select[data-behavior~=select2]").each ->
      select2options = $.extend({}, UI.select2defaults, $(this).data("select2options"))
      dataAttrs = $(this).data()
      if dataAttrs and dataAttrs.allowhtml
        select2options.escapeMarkup = (m) -> return m
      UI.select2($(this), select2options)

  UI.select2 = ($el, options) ->
    $el.select2 options

  UI.autosizeTextarea = (context) ->
    $context = get_safe_context(context)
    $context.find("textarea:visible").each ->
      autosize $(this)

  UI.setup_form_ui = (context) ->
    UI.setup_validation context
    UI.setup_datetime_inputs context
    UI.setup_select2 context
    UI.autosizeTextarea context

  # non-setup form ui things
  UI.setup_clear_inputs = (context) ->
    context.find("[data-behavior~=clear-inputs]").each ->
      $container = $(this)
      $removeIcon = $container.find(".trigger-remove")
      $inputs = $container.find("input")

      clearInputs = (event) ->
        event.preventDefault()
        i = 0
        while i < $inputs.length
          $input = $($inputs[i])
          if $input.attr("type") != "submit"
            $input.val null
          i++

      $removeIcon.on "click", clearInputs

  UI.setup_toggle_remove_rows = (context) ->
    UI.setup_clear_inputs context
    context.find("[data-behavior~=toggle-remove-row]").each ->
      $addLink = $(this).find(".trigger-toggle-inputs")
      $removeInputs = $(this).find(".trigger-remove")
      $allowToggleInputs = $(this).find(".allow-toggle-inputs")
      $inputs = $(this).find("input")
      isDefaultVisible = $(this).hasClass("js-default-visible")

      initializeInputs = ->
        firstInputVal = $($inputs[0]).val()
        inputNotEmpty = firstInputVal.length != 0
        inputNotZero = firstInputVal != "0"
        if isDefaultVisible or inputNotEmpty and inputNotZero
          showInputFields()
        else
          hideInputFields()
          $addLink.removeClass "hidden"

      showInputFields = (event) ->
        if event
          event.preventDefault()
        $allowToggleInputs.addClass "active"

      hideInputFields = ->
        $allowToggleInputs.removeClass "active"

      $addLink.on "click", showInputFields
      $removeInputs.on "click", hideInputFields
      initializeInputs()
)(jQuery)

# Setup UI controls on page when loaded.
$ ->
  UI = contently.ui
  UI.setup_form_ui()
  # Setup CSRF token helpers
  csrfParam = $("meta[name=csrf-param]").attr("content")
  csrfToken = $("meta[name=csrf-token]").attr("content")

  UI.getCsrfParam = ->
    csrfParam

  UI.getCsrfToken = ->
    csrfToken

  UI.getCsrfAsParameter = ->
    UI.getCsrfParam() + "=" + encodeURIComponent(UI.getCsrfToken())



// WEBPACK FOOTER //
// ./app/javascript/lib/contently.ui.js.coffee